import React, { SyntheticEvent } from 'react';
import { Dropdown, DropdownItemProps, Icon } from 'semantic-ui-react';
import { Device } from '../logic/Device';
import { deepCopy } from '../logic/utils';

import './HeraldryWidget.css';
import './General.css';

interface Props {
    device: Device | undefined,
    changeDevice: (device: Device | undefined) => void,
    colors: string,
    changeColors: (colors: string) => void,
}
interface State {
    respinning?: boolean;
    tick: number;
}

export class General extends React.Component<Props, State> {
    constructor(props: Props) {
        super(props);
        this.state = {
            tick: 0,
        };
    }

    private static colorOptions: DropdownItemProps[] = [
        { key: '1', text: 'Historical', value: 'Historical', },
        { key: '2', text: 'Fantasy', value: 'Fantasy', },
    ];

    private static shapeOptions: DropdownItemProps[] = [
        { key: 'CRESCENT', value: 'CRESCENT', text: 'Crescent', image: { src: require("../assets/shields/CRESCENT.png") }, desc: "The crescent shield was used by some ancient Greeks, and makes a distinct shape for fantasy races such as Gnomes.", path: "https://content.worldspinner.com/heraldry/portraits/Gnome.webp" },
        { key: 'DWARF', value: 'DWARF', text: 'Dwarf', image: { src: require("../assets/shields/DWARF.png") }, desc: "Dwarves are known for their sturdy metalwork, including their shields.", path: "https://content.worldspinner.com/heraldry/portraits/Dwarf.webp" },
        { key: 'EGYPTIAN', value: 'EGYPTIAN', text: 'Egyptian', image: { src: require("../assets/shields/EGYPTIAN.png") }, desc: "For centuries the Egyptians favored this shield shape.", path: "https://content.worldspinner.com/heraldry/portraits/Egyptian.webp" },
        { key: 'ELEGANT', value: 'ELEGANT', text: 'Elegant', image: { src: require("../assets/shields/ELEGANT.png") }, desc: "Tall and elegant, this shape works well for Elves.", path: "https://content.worldspinner.com/heraldry/portraits/Elf.webp" },
        { key: 'FANCY', value: 'FANCY', text: 'Fancy', image: { src: require("../assets/shields/FANCY.png") }, desc: "A more ornate shape is favored by some, especially Halflings.", path: "https://content.worldspinner.com/heraldry/portraits/Halfling.webp" },
        { key: 'FLAG', value: 'FLAG', text: 'Flag', image: { src: require("../assets/shields/FLAG.png") }, desc: "A coat of arms can also be placed upon a flag." },
        { key: 'GOURD', value: 'GOURD', text: 'Gourd', image: { src: require("../assets/shields/GOURD.png") }, desc: "This unique shape was historically used by the Chinese.", path: "https://content.worldspinner.com/heraldry/portraits/Chinese.webp" },
        { key: 'TROJAN', value: 'TROJAN', text: 'Greek', image: { src: require("../assets/shields/TROJAN.png") }, desc: "The ancient Greeks used round shields, sometimes with this distinctive scalloped shape.", path: "https://content.worldspinner.com/heraldry/portraits/Greek.webp" },
        { key: 'HEATER', value: 'HEATER', text: 'Heater', image: { src: require("../assets/shields/HEATER.png") }, desc: "The classic 'heater' shape was used by many European cultures, including the English.", path: "https://content.worldspinner.com/heraldry/portraits/English.webp" },
        { key: 'HEX', value: 'HEX', text: 'Hex', image: { src: require("../assets/shields/HEX.png") }, desc: "A tall hexagonal design was favored by some Germanic peoples.", path: "https://content.worldspinner.com/heraldry/portraits/German.webp" },
        { key: 'LOZENGE', value: 'LOZENGE', text: 'Lozenge', image: { src: require("../assets/shields/LOZENGE.png") }, desc: "This diamond shape was historically used to the heraldry of upper-class and noble women.", path: "https://content.worldspinner.com/heraldry/portraits/Woman.webp" },
        { key: 'ORC', value: 'ORC', text: 'Orc', image: { src: require("../assets/shields/ORC.png") }, desc: "Orcs often use brutal metal shields, as much a weapon as a defense.", path: "https://content.worldspinner.com/heraldry/portraits/Orc.webp" },
        { key: 'OVAL', value: 'OVAL', text: 'Oval', image: { src: require("../assets/shields/OVAL.png") }, desc: "A tall oval shield was the favored defense of many groups, from African to Celtic.", path: "https://content.worldspinner.com/heraldry/portraits/African.webp" },
        { key: 'ROUND', value: 'ROUND', text: 'Round', image: { src: require("../assets/shields/ROUND.png") }, desc: "The round shield was a favorite of Vikings.", path: "https://content.worldspinner.com/heraldry/portraits/Viking.webp" },
        { key: 'SCUTUM', value: 'SCUTUM', text: 'Scutum', image: { src: require("../assets/shields/SCUTUM.png") }, desc: "The tall rectangular scutum shield was a hallmark of the Roman legions.", path: "https://content.worldspinner.com/heraldry/portraits/Roman.webp" },

    ];


    public render() {
        if (!this.props.device) {
            return <div />;
        }
        const shapeOption = General.shapeOptions.find((opt) => opt.value === this.props.device!.shield);
        return <div>
            <div id="general-respin-div">
                <div id="general-respin-button" onClick={() => this.props.changeDevice(undefined)}>
                    <Icon name="redo alternate" size="large" loading={this.state.respinning} /> &nbsp; Respin a random coat of arms&nbsp;
                </div>
            </div>

            <div className="heraldry-dropdown">
                <div className="heraldry-dropdown-label">Colors:</div>
                <div className="heraldry-dropdown-menus">
                    <div className="heraldry-dropdown-menu">
                        <Dropdown compact selection options={General.colorOptions} value={this.props.colors}
                            onChange={(event: SyntheticEvent, data: object) => this.props.changeColors((data as any).value)} />
                    </div>
                </div>
            </div>

            <div className="heraldry-dropdown">
                <div className="heraldry-dropdown-label">Shield:</div>
                <div className="heraldry-dropdown-menus">
                    <div className="heraldry-dropdown-menu">
                        <div>
                            <div>
                                <Dropdown key={this.state.tick} selection options={General.shapeOptions} value={this.props.device.shield}
                                    onChange={(event: SyntheticEvent, data: object) => this.onChangeShieldShape((data as any).value)} />
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            {<div id="general-shield-info">
                <div>
                    {shapeOption?.desc}
                </div>
                {shapeOption?.path && <a href="https://worldspinner.com/portraits.html">
                    <div id="general-shield-portrait">
                        <div>
                            <img src={shapeOption?.path} width={200} alt="portrait" />
                        </div>
                        <div>
                            Portrait made with <u>PortraitWorks</u>.
                        </div>
                    </div>
                </a>}
            </div>}
        </div>;
    }

    // private async onRespin() {
    //     try {
    //         console.log("onRespin...");
    //         this.setState ({respinning: true});
    //         const design = await apiGetRandomDesign();
    //         console.log("result: ", design);
    //         this.props.changeDevice(design);
    //         this.setState({tick: this.state.tick+1});
    //     } catch (e) {
    //         console.log("onRespin ERROR: ", e);
    //     }
    //     this.setState ({respinning: false});
    // }

    private onChangeShieldShape(shape: string) {
        console.log("General.onChangeShieldShape: " + shape);
        const design: Device = deepCopy(this.props.device);
        design.shield = shape;
        this.props.changeDevice(design);
        // this.setState({active: shape !== "NONE" });
    }

}
